export default [
  {
    path: '/feedback',
    component: () => import('./views/Index'),
    name: 'feedback',
    redirect: { name: 'feedback-list' },
    children: [
      {
        path: '',
        name: 'feedback-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'notification-feedback',
        },
      },
    ],
  },
]
